module.exports = __webpack_public_path__ + "components/ServicesCategories/icons/nieruchomosci.svg?635f249d";


//////////////////
// WEBPACK FOOTER
// ./components/ServicesCategories/icons/nieruchomosci.svg
// module id = 1868
// module chunks = 0